<template>
  <th class="text-center">
    <v-dialog v-model="dialog" max-width="400px" content-class="rounded-xl">
      <template v-slot:activator="{ on }">
        <v-btn fab x-small text v-on="on">
          <v-icon small>mdi-wrench</v-icon>
        </v-btn>
      </template>
      <v-card class="roundex-xl">
        <v-card-title>
          <span class="headline"> Фильтр разницы времени<br /> </span>
          <v-spacer></v-spacer>
          <v-btn @click="show = !show" icon small
            ><v-icon>mdi-message-question-outline</v-icon></v-btn
          >
          <v-tooltip v-model="show" bottom>
            <span>
              Первое значение: разница среднего и минимального времени<br />
              Второе значение: разница максимального и среднего времени<br />
            </span>
          </v-tooltip>
          <v-spacer></v-spacer>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-select
                    :items="first_diff"
                    item-value="value"
                    item-text="value"
                    clearable
                    label="СР - МИН"
                    :menu-props="{
                      bottom: true,
                      offsetY: true,
                      minWidth: 150,
                      transition: 'scale-transition',
                    }"
                    @change="changed"
                    v-model="selectedFirst"
                  >
                  </v-select>
                </v-col>
                <v-col>
                  <v-select
                    ref="select"
                    :items="sec_diff"
                    clearable
                    item-value="value"
                    item-text="value"
                    label="МАКС - СР"
                    :menu-props="{
                      bottom: true,
                      offsetY: true,
                      minWidth: 150,
                      transition: 'scale-transition',
                    }"
                    @change="changed"
                    v-model="selectedSecond"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </th>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      show: false,
      selectedFirst: "",
      selectedSec: "",
      first_diff: [
        { id: -1, value: "" },
        { id: 1, value: "1" },
        { id: 2, value: "2" },
        { id: 3, value: "3" },
        { id: 4, value: "4" },
        { id: 5, value: "5" },
        { id: 6, value: "6" },
        { id: 7, value: "7" },
        { id: 8, value: "8" },
        { id: 9, value: "9" },
        { id: 10, value: "10" },
        { id: 11, value: "11" },
        { id: 12, value: "12" },
        { id: 13, value: "13" },
        { id: 14, value: "14" },
        { id: 15, value: "15" },
        { id: 16, value: "16" },
        { id: 17, value: "17" },
        { id: 18, value: "18" },
        { id: 19, value: "19" },
        { id: 20, value: "20" },
        { id: 21, value: "21" },
        { id: 22, value: "22" },
      ],
      sec_diff: [
        { id: -1, value: "" },
        { id: 1, value: "1" },
        { id: 2, value: "2" },
        { id: 3, value: "3" },
        { id: 4, value: "4" },
        { id: 5, value: "5" },
        { id: 6, value: "6" },
        { id: 7, value: "7" },
        { id: 8, value: "8" },
        { id: 9, value: "9" },
        { id: 10, value: "10" },
        { id: 11, value: "11" },
        { id: 12, value: "12" },
        { id: 13, value: "13" },
        { id: 14, value: "14" },
        { id: 15, value: "15" },
        { id: 16, value: "16" },
        { id: 17, value: "17" },
        { id: 18, value: "18" },
        { id: 19, value: "19" },
        { id: 20, value: "20" },
        { id: 21, value: "21" },
        { id: 22, value: "22" },
        { id: 23, value: "23" },
      ],
    };
  },
  methods: {
    ...mapActions(["setFilterKey", "deleteFilterKey"]),
    ...mapGetters(["getSettings"]),
    changed: function () {
      let key = "round_time__time_diff";
      if (this.selectedFirst == "" && this.selectedSecond == "") {
        this.deleteFilterKey({ key_to_delete: key });
        this.$emit("filter_update");
        return;
      }
      var first_diff = this.selectedFirst ? this.selectedFirst : "-1";
      var second_diff = this.selectedSecond ? this.selectedSecond : "-1";
      let value = first_diff + "|" + second_diff;

      this.setFilterKey({ key, value });
      this.$emit("filter_update");
    },
    findValueByPrefix: function (object, prefix) {
      for (var property in object) {
        if (
          Object.prototype.hasOwnProperty.call(object, property) &&
          property.toString().startsWith(prefix)
        ) {
          return [property, object[property]];
        }
      }
    },
  },

  mounted() {},
  created() {
    let settings = this.getSettings().filters;

    let result = this.findValueByPrefix(settings, "round_time__time_diff");
    if (!result) {
      return;
      // TODO: intervals
    }
    let splitted = result[1].split("|");
    this.selectedFirst = splitted[0];
    this.selectedSecond = splitted[1];
    // this.selectedFirst = hour;
    // this.selectedSecond = minute;
  },
};
</script>

<style>
.select.v-text-field.v-text-field--enclosed:not(.v-text-field--dense)
  > .v-input__control
  > .v-input__slot {
  overflow: hidden !important;
  padding-right: 4px !important;
  padding-left: 4px !important;
}
.v-input__icon {
  padding-top: 3px !important;
  min-width: 15px !important;
  width: 12px !important;
}
</style>
